import { tv } from 'tailwind-variants'

export const userProfilePreviewWithModalVariants = tv({
  slots: {
    modalBase: 'pb-4',
    userPreviewContainer: 'flex-col items-start gap-4 py-2',
  },
  variants: {
    isMobileSize: {
      true: { modalBase: 'px-0', userPreviewContainer: 'px-6' },
      false: { userPreviewContainer: 'px-10' },
    },
    hasCreatedCommunities: {
      true: { userPreviewContainer: 'py-2' },
      false: { userPreviewContainer: 'py-4' },
    },
  },
  defaultVariants: {
    isMobileSize: false,
    hasCreatedCommunities: false,
  },
  compoundVariants: [
    {
      isMobileSize: false,
      hasCreatedCommunities: true,
      class: {
        userPreviewContainer: 'flex-row justify-between',
        modalBase: 'w-[788px] max-w-full',
      },
    },
  ],
})
